<template>
  <div class="title_page">
      <div class="container">
        <div class="wrap_title" v-if="get_contact_info.seo">
          <div class="title_text">
            <h1>{{get_contact_info.seo.title}}</h1>
          </div>
          <div class="title_desc">
            <p v-html="get_contact_info.seo.desc"></p>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "titleArea",
   computed: {
    ...mapGetters({
      get_contact_info: "get_contact_info",
    }),
  },
  methods: {
    ...mapActions({
      contact_info_api: "contact_info_api",
    }),
  },
  mounted() {
    this.contact_info_api();
  },
}
</script>
<style lang="scss" scoped>
 .title_page {
    padding: 55px 0px 0px 0px;
    .wrap_title {
      display: flex;
      align-items: flex-start;
      flex-wrap: wrap;
      .title_text {
        h1 {
          line-height: 1.1;
          font-size: 5rem;
          font-family: "Oswald", sans-serif;
          text-transform: uppercase;
          font-weight: 700;
          margin: 0;
          color: white;
          position: relative;
          padding-bottom: 40px;
          width: 38vw;
          &::after {
            content: "";
            position: absolute;
            left: 0;
            bottom: 0px;
            width: 80px;
            height: 4px;
            background-color: var(--active_color);
          }
        }
      }

      .title_desc {
        padding: 0;
        max-width: 625px;
        padding-left: 40px;
        p {
          margin: 0;
          padding: 0px 20px 8px 0px;
          font-size: 16px;
          font-weight: 300;
          line-height: 30px;
          color: #d8d8d8;
          font-family: "Roboto", sans-serif;
        }
      }
    }
  }
   @media(max-width:992px){
    .title_page .wrap_title .title_text h1 {
    line-height: 1.1;
    font-size: 3rem;
    padding-bottom: 20px;
    width: 100%;
}
.title_page .wrap_title .title_desc p {
    margin: 0;
    padding: 0px 10px 8px 0px;
    font-size: 13px;
    font-weight: 300;
    line-height: 22px;
}
  }
    @media(max-width:767px){
    .title_page .wrap_title .title_text h1 {
    line-height: 1.1;
    font-size: 2rem;
    padding-bottom: 20px;
    width: 100%;
}
.title_page .wrap_title .title_desc p {
    margin: 0;
    padding: 0px 10px 8px 0px;
    font-size: 12px;
    font-weight: 300;
    line-height: 22px;
}
.title_page .wrap_title {
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    flex-direction: column;
}
.title_page .wrap_title .title_desc {
    padding: 0;
    flex: 0 0 50%;
    max-width: 100%;
    padding-left: 0px;
    padding-top: 20px;
}

  }
</style>